<div id="codelistCard" class="control-card-white">
  <div class="control-card-header">
    <ng-container i18n="@@editDescription_title">Modifica descrizione</ng-container>
    <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
  </div>

  <div>

    <form [formGroup]="editDescriptionForm">
      <table class="simple-table user-add-table">
        <tr>
          <td width="180px" class="text-dark" i18n="@@editDescription_description">Descrizione</td>
          <td><input id="name-input" formControlName="description" [(ngModel)]="newDescription" /></td>
        </tr>
      </table>
    </form>

    <a (click)="confirm()" class="button user-add-button" id="confirmButton">
      <ng-container i18n="@@editDescription_confirm">Conferma</ng-container>
      <span>
        <fa-icon icon="check"></fa-icon>
      </span>
    </a>

    <a (click)="cancel()" class="button button-red" id="cancelButton">
      <ng-container i18n="@@editDescription_cancel">Cancel</ng-container>
      <span>
        <fa-icon icon="times"></fa-icon>
      </span>
    </a>

  </div>
